import React from 'react';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const GiveawayEditor = ({ content, onChange }) => {
  const handleChange = (field, value) => {
    onChange({
      ...content,
      [field]: value
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-destructive/10 flex items-center justify-center">
          <Icon name="Gift" size={20} color="var(--color-destructive)" />
        </div>
        <div>
          <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
            Çekiliş Günü İçeriği
          </h4>
          <p className="caption text-muted-foreground">
            Çekiliş detaylarını ve katılım koşullarını belirleyin
          </p>
        </div>
      </div>
      <Checkbox
        label="Çekilişi Aktif Et"
        description="Bu seçenek işaretlendiğinde kullanıcılar çekilişe katılabilir"
        checked={content?.isActive || false}
        onChange={(e) => handleChange('isActive', e?.target?.checked)}
      />
      <Input
        label="Çekiliş Başlığı"
        type="text"
        placeholder="Örn: Haftalık Hediye Çekilişi"
        value={content?.title || ''}
        onChange={(e) => handleChange('title', e?.target?.value)}
        required
        description="Çekilişin çekici başlığı"
      />
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Çekiliş Açıklaması
          <span className="text-destructive ml-1">*</span>
        </label>
        <textarea
          className="flex w-full rounded-lg border border-input bg-input px-4 py-3 text-sm focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-3 disabled:cursor-not-allowed disabled:opacity-50 min-h-32 md:min-h-40"
          placeholder="Çekiliş detaylarını ve hediyeyi açıklayın..."
          value={content?.description || ''}
          onChange={(e) => handleChange('description', e?.target?.value)}
          required
        />
        <p className="caption text-muted-foreground mt-2">
          Hediyeyi, katılım koşullarını ve çekiliş tarihini belirtin
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Hediye"
          type="text"
          placeholder="Örn: Araç Kokusu Seti"
          value={content?.prize || ''}
          onChange={(e) => handleChange('prize', e?.target?.value)}
          required
        />

        <Input
          label="Çekiliş Tarihi"
          type="date"
          value={content?.drawDate || ''}
          onChange={(e) => handleChange('drawDate', e?.target?.value)}
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Katılım Koşulları
        </label>
        <textarea
          className="flex w-full rounded-lg border border-input bg-input px-4 py-3 text-sm focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-3 disabled:cursor-not-allowed disabled:opacity-50 min-h-24"
          placeholder="Katılım için gerekli koşulları listeleyin..."
          value={content?.terms || ''}
          onChange={(e) => handleChange('terms', e?.target?.value)}
        />
        <p className="caption text-muted-foreground mt-2">
          Örn: Instagram kullanıcı adı girme zorunluluğu, yaş sınırı vb.
        </p>
      </div>
      <div className="p-4 md:p-6 rounded-lg bg-destructive/10 border border-destructive/20">
        <div className="flex items-start gap-3">
          <Icon name="AlertCircle" size={20} color="var(--color-destructive)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground font-medium mb-1">
              Önemli Bilgi
            </p>
            <p className="caption text-muted-foreground">
              Çekiliş aktif olduğunda kullanıcılar "Katıl" butonu ile çekilişe dahil olabilir. Katılımcı listesini aşağıdaki bölümden görüntüleyebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiveawayEditor;